// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SidePanel_Wrapper__1iwwX","Container":"SidePanel_Container__39ZHQ","Open":"SidePanel_Open__3iOcC"};